import { Service } from 'src/common/models/service'
import * as Styles from './styles'
import { formatToCurrency, getServiceInitials } from 'src/common/util'
import { Badge, Image } from 'antd';
import { SystemDescriptions } from 'src/common/descriptions';

interface Props {
    service: Service
    onClick: (service: Service) => void
}

export const ServiceCard = (props: Props) => {

    const descriptions = SystemDescriptions.PAGES.SERVICE_CONTRACT.CREATE_SERVICE_CONTRACT
    const commonDescriptions = SystemDescriptions.PAGES.COMMON

    const handleCardClick = () => {
        props.onClick(props.service)
    }

    const renderServiceImage = () => (
        <Image
            style={{ position: 'relative', borderTopLeftRadius: 8, borderTopRightRadius: 8, }}
            width={'100%'}
            src={props.service.imageUrl}
            preview={false}
        />
    )

    const renderRibbon = () => {
        return <Badge.Ribbon text={descriptions.MONTHLY_SYMBOL} >
            {renderContent()}
        </Badge.Ribbon>
    }

    const renderContent = () => (
        <Styles.ServiceCard
            onClick={handleCardClick}
        >
            <Styles.ServiceImageContainer>
                {
                    props.service.imageUrl && props.service.imageUrl.trim().length > 0
                        ? renderServiceImage()
                        : getServiceInitials(props.service.name)
                }
            </Styles.ServiceImageContainer>
            <Styles.DetailContainer>
                <Styles.PriceLabel>
                    {commonDescriptions.CURRENCY_SYMBOL} {formatToCurrency(props.service.price.toString())}
                </Styles.PriceLabel>
                <Styles.NameLabel>
                    {props.service.name}
                </Styles.NameLabel>
            </Styles.DetailContainer>
        </Styles.ServiceCard>
    )

    return (
        props.service.isMonthly
            ? renderRibbon()
            : renderContent()
    )
}
